import {Routes} from 'common/src/modules/routing/routing.config';
import routingService from 'common/src/modules/routing/routing.service';
import {CampaignStep} from 'common/src/modules/campaignWorkflow/campaignWorkflow.enums';
import {CampaignTreeType} from 'common/src/modules/campaigns/campaigns.types';

export default function getCampaignTreeType() {
  return routingService.isMatchRoute(Routes.CampaignWorkflowConceptPlan, location.pathname) ||
    routingService.isMatchRoute(Routes.ConceptPlanPublic, location.pathname) ||
    location.search.includes(CampaignStep.ConceptPlan)
    ? CampaignTreeType.Concept
    : CampaignTreeType.Campaign;
}
